export default {
  'en': {
    'heading': 'Ready to move?',
    'sub_heading': 'We like to move it move it',
    'paragraph': '<p>If you have questions, need our help - or you just want to hear more about our platforms, services etc., you\'re always welcome to contact us. And we will help you the best we can as fast as we can.</p>',
    'chat_txt': 'Catch us on chat',
    'phone_txt': 'Call us on',
    'em_txt': 'Send an e-mail to'
  },
  'da': {
    'heading': 'KLAR TIL AT RYKKE?',
    'sub_heading': 'We like to move it move it',
    'paragraph': '<p>Hvis du har nogen spørgsmål, har brug for vores hjælp – eller du bare gerne vil høre mere om vores platforme, services osv., så er du altid velkommen til at kontakte os. Så vil vi hjælpe dig så godt vi kan, så hurtigt vi kan.</p>',
    'chat_txt': 'Fang os på chatten',
    'phone_txt': 'Ring til os på',
    'em_txt': 'Send en e-mail til'
  }
}



// WEBPACK FOOTER //
// ./src/multilanguage/ready.js